module.exports = __webpack_public_path__ + "static/media/sprite.721d07f4.svg";